import UserIncentiveDistribution from "components/UserIncentiveDistribution/UserIncentiveDistribution";

import EarnPageLayout from "./EarnPageLayout";

export default function EarnDistributionsPage() {
  return (
    <EarnPageLayout>
      <UserIncentiveDistribution />
    </EarnPageLayout>
  );
}
